import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Plus, Scale, RefreshCw, WifiOff } from 'lucide-react';

export function DashboardHeader({ count, isOfflineData, refreshing, onRefresh }) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
      <div>
        <h1 className="font-serif text-3xl md:text-4xl text-white drop-shadow-lg">My Trips</h1>
        <p className="text-white/80 mt-1">
          {count} {count === 1 ? 'itinerary' : 'itineraries'} saved
        </p>
      </div>
      <div className="flex flex-wrap gap-3">
        {isOfflineData && (
          <Button
            className="bg-amber-500/90 hover:bg-amber-500 text-white font-medium px-4 py-3 rounded-full transition-all duration-300 flex items-center gap-2 border border-amber-400/30"
            onClick={onRefresh}
            disabled={refreshing}
            data-testid="offline-refresh-btn"
          >
            <RefreshCw className={`w-4 h-4 ${refreshing ? 'animate-spin' : ''}`} /> Refresh
          </Button>
        )}
        <Button
          className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-medium px-5 py-3 rounded-full transition-all duration-300 flex items-center gap-2 border border-white/20"
          onClick={() => navigate('/compare')}
          data-testid="compare-btn"
        >
          <Scale className="w-4 h-4" /> Compare Trips
        </Button>
        <Button
          className="bg-gold hover:bg-gold-light text-ocean font-semibold px-6 py-3 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center gap-2"
          onClick={() => navigate('/new-trip')}
          data-testid="new-trip-btn"
        >
          <Plus className="w-4 h-4" /> Plan New Trip
        </Button>
      </div>
    </div>
  );
}

export function OfflineDataBanner({ cachedAt }) {
  return (
    <div className="mb-4 bg-amber-500/15 backdrop-blur-sm border border-amber-400/30 rounded-xl px-4 py-3 flex items-center gap-3" data-testid="offline-data-banner">
      <WifiOff className="w-5 h-5 text-amber-300 flex-shrink-0" />
      <div className="flex-1">
        <p className="text-white text-sm font-medium">Viewing cached trips</p>
        {cachedAt && (
          <p className="text-white/60 text-xs mt-0.5">
            Last synced: {new Date(cachedAt).toLocaleString()}
          </p>
        )}
      </div>
    </div>
  );
}
